<template>
  <div class="grid pb-0 bg-white" style="height: calc(100vh - 90px)" ref="viewPage">
    <div ref="pageTitle" class="grid-title">
      <h4 class="mr-auto">{{$t('UPDATE_FORMULAR')}}</h4>
      <div>
        <v-row class="pr-3">
          <v-col class="text-right p-0">
            <v-btn
              depressed
              color="primary"
              class="mr-2"
              @click="$router.push({ name: 'calculate' })"
            >
              <v-icon light size="20px" left>calculate</v-icon>
              {{$t('LIST_FORMULAR')}}
            </v-btn>
            <v-btn
              class="mt-0 mr-2"
              color="primary"
              @click="$router.push({ name: 'master-rate-overview' })"
            >
              <v-icon light size="20px" left>arrow_back</v-icon>
             {{$t('DERIVED')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="grid-body border-top-unset">
      <div class="body-room-sale">
        <div class="grid pb-0">
          <div class="grid-body">
            <v-progress-linear
              color="secondary"
              indeterminate
              rounded
              height="3"
              v-if="isLoading"
            >
            </v-progress-linear>
            <div v-if="!isLoading">
              <v-card-text ref="options">
                <v-row align="center">
                  <v-col sm="6" class="pt-0 pb-0 d-flex align-items-center">
                    <label class="mr-3 text-nowrap">
                      {{ $t('DERIVED_PRODUCT') }}
                    </label>
                    <v-autocomplete
                      item-text="text"
                      item-value="value"
                      :items="listProduce"
                      v-model="selectedProduce"
                      outlined
                      dense
                      chips
                      multiple
                      :placeholder="$t('METADATA')"
                      @change="changeSearchCondition()"
                    >
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1">
                          <a
                            class="text-primary"
                            @click="
                              selectedProduce = listProduce.map(
                                (e) => e.value
                              );
                              changeSearchCondition()
                            "
                            >{{ $t("SELECT_ALL") }}</a
                          >
                          |
                          <a
                            class="text-primary"
                            @click="selectedProduce = [];
                            changeSearchCondition()"
                            >{{ $t("UN_SELECT_ALL") }}</a
                          >
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip 
                        v-if="index === 0" 
                        color="primary"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="
                          removeChips(index, selectedProduce);
                          changeSearchCondition()
                        "
                        >
                          <span :title="item.text" style="max-width:250px; white-space: nowrap; text-overflow: ellipsis; overflow:hidden;">{{ item.text }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ selectedProduce.length - 1 }})</span
                        >
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="6" class="pt-0 pb-0 d-flex align-items-center">
                    <label class="mr-3 text-nowrap">
                      {{ $t("SELECT_TYPE") }}
                    </label>
                    <v-autocomplete
                      item-text="text"
                      item-value="value"
                      :items="applicableType"
                      v-model="applicableTypeSelected"
                      outlined
                      dense
                      chips
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1">
                          <a
                            class="text-primary"
                            @click=" applicableTypeSelected = applicableType.map((e) => e.value)"
                            >{{ $t("SELECT_ALL") }}</a
                          >
                          |
                          <a
                            class="text-primary"
                            @click="applicableTypeSelected = []"
                            >{{ $t("UN_SELECT_ALL") }}</a
                          >
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip 
                        v-if="index === 0" 
                        color="primary"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="removeChips(index, applicableTypeSelected)"
                        >
                          <span>{{ item.text }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ applicableTypeSelected.length - 1 }})</span
                      >
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
              <div class="tables-scroll-x-container" ref="tableSetup" :style="{ 'max-height': maxHeight + 'px' }" @scroll="listFomulaLoadMores">
                <table class="tables-scroll-x caculate-by-date">
                  <thead>
                    <th class="sticky-column left text-left mw-250 mxw-250">
                      {{$t('APPLY_DATE')}}
                    </th>
                    <th class="sticky-column left text-left mw-250 mxw-250">
                      {{$t('MASTER_PRODUCT')}} (M)
                    </th>
                    <th class="px-1" v-for="(item, index) in filterRestrictions" :key="index" :class="item.bitFlag != 0 ? 'cw-60 text-center px-2' : ''">
                      {{item.shortText}}
                    </th>
                    <th class="sticky-column right text-center">
                      {{$t('ACTION')}}
                    </th>
                  </thead>
                  <tbody>
                    <template v-for="(item, i) in listData">
                      <tr :key="'roomRate-'+i">
                        <td class="sticky-column left px-3 mb-0 font-weight-bold restriction-name pt-1" colspan="2">
                            {{ item.DERIVED_PRODUCT }}
                        </td>
                        <td :colspan="filterRestrictions.length" class="pt-1"></td>
                        <td class="sticky-column right pt-1"></td>
                      </tr>
                      <tr v-for="(date, index) in item.dates.filter((e) => e.active !== 2)" :key="'roomRate-'+i+'dateRow-'+index">
                        <td class="sticky-column left date-picker px-3 pt-1">
                          <date-picker
                            :disabled-date="notBeforeToday"
                            @input="changDate(detail)"
                            :confirm="true"
                            :confirm-text="$t('CONFIRM')"
                            :clearable="false"
                            :popup-class="'popup-calendar-desktop-detailhotel'"
                            v-model="date.dateSelect"
                            :lang="languageDate"
                            :format="'DD/MM/YYYY'"
                            :shortcuts="[]"
                            range
                            placeholder="Select date range"
                            class=""
                          >
                          </date-picker>
                        </td>
                        <td class="sticky-column left room-master p-1">
                          <div class="cut-text" :title="item.MASTER_PRODUCT">
                            {{item.MASTER_PRODUCT}}
                          </div>
                        </td>
                        <td class="p-1" v-for="(data, idx) in filterRestrictions" :key="idx" :class="data.bitFlag != 0 ? 'cw-60 text-center px-2' : ''">
                          <rate-derivation
                            v-if="data.bitFlag == 0 && (date.restrictionType & bitSetupPrice) !== 0"
                            :isEdit="date.isEdit"
                            :rateAdditional="date.rateAdditional"
                            @changeRateAdditional="(val) => date.rateAdditional = val"
                            :rateIndex="date.rateIndex"
                            @changeRateIndex="(val) => date.rateIndex = val"
                            :rateSupplement="date.rateSupplement"
                            @changeRateSupplement="(val) => date.rateSupplement = val"
                            :roomRateDerivationsDenominatorList="date.roomRateDerivationsDenominatorList"
                            @changeRateDerivationsDenominatorList="(val) => date.roomRateDerivationsDenominatorList = val"
                          ></rate-derivation>
                          <span v-else-if="data.bitFlag == 2048 && data.value == 'price'">
                            <svg class="cursor-default" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                              <path fill="#335073" :d="(date.restrictionType & data.bitFlag) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                              'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                            </svg>
                          </span>
                          <span v-else @click="toggleRestriction(date, data.bitFlag)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                              <path fill="#335073" :d="(date.restrictionType & data.bitFlag) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                              'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                            </svg>
                          </span>
                        </td>
                        <td class="sticky-column right text-center px-2">
                          <span class="ml-1" :title="$t('DELETE')" @click="date.active = 2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="20" viewBox="0 0 36 20">
                              <rect x="0.5" y="0.5" width="34" height="19" rx="2" fill="none" stroke="red" stroke-width="1"/>
                              <g transform="translate(9.5, 1.5)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                                  <path fill="red" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6z" />
                                </svg>
                              </g>
                            </svg>
                          </span>
                        </td>
                      </tr>
                      <tr :key="'roomRate-'+i+'addDate'">
                        <td colspan="2" class="sticky-column left px-2 row-add-date border-bottom pb-1">
                          <v-btn
                            color="primary"
                            outlined
                            x-small
                            @click="addDatePriodSpecialPrice(item)"
                          >
                            <v-icon color="#173d8f" small>add</v-icon>
                            <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                          </v-btn>
                        </td>
                        <td :colspan="filterRestrictions.length" class="border-bottom pb-1"></td>
                        <td class="sticky-column right border-bottom pb-1"></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div v-if="dataRoomRateLoading" class="text-center py-2" style="position:sticky; left: 0;">
                  <v-progress-circular
                    :width="2"
                    color="gray"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </div>
              <div v-if="dataRoomRateFormulaByDate.length == 0" class="text-center py-3">{{$t("NO_DATA")}}</div>
              <div v-if="dataRoomRateFormulaByDate.length > 0" class="d-flex justify-content-end py-3" :class="isScroll ? 'mr-50' : ''">
                  <v-btn color="primary" :disabled="isLoading" class="mr-2" @click="updateFormula()">{{$t("UPDATE")}}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-btn
      v-if="!isNote"
      color="primary"
      dark
      bottom
      left
      class="btn-note"
      @click="
        isNote = true;
        maxHeight = maxHeight - 80;
        checkScroll();
      "
      style="z-index: 2; bottom: 30px !important;"
    >
      <i class="icon-category fs-16"></i>
    </v-btn>
    <v-col
      ref="notes"
      v-if="isNote"
      class="border-top d-flex align-items-center"
      style="position: absolute; bottom: 0; background: #fff; z-index: 8"
    >
      <ul class="tools-icon-description">
        <li v-for="(restriction, index) in applicableType.filter((e) => e.value != 'price')" :key="'tools-icon-description'+index">
          <span
            class="font-weight-bold text-uppercase text-nowrap"
            :style="{ fontSize: '11px' }"
            >{{ restriction.shortText }}:</span
          >
          <span class="text-primary pl-2 text-nowrap">{{
            restriction.text
          }}</span>
        </li>
        <li>
          <span class="d-flex">
          <v-checkbox
            class="m-0 p-0 note-checkbox"
            :input-value="true"
            disabled
          ></v-checkbox>
          <span class="text-primary text-nowrap">{{
            $t('APPLY')
          }}</span>
          </span>
        </li>
        <li>
          <span class="d-flex">
            <v-checkbox
              class="m-0 p-0 note-checkbox"
              :input-value="false"
              disabled
            ></v-checkbox>
            <span class="text-primary text-nowrap">{{$t('NOT_APPLY')}}</span>
          </span>
        </li>
      </ul>
      <v-btn
        class="ml-3 py-5"
        dark
        small
        color="primary"
        @click="
          isNote = false;
          maxHeight = maxHeight + 80;
          checkScroll();
        "
      >
        <i class="icon-expand_more fs-16"></i>
      </v-btn>
    </v-col>
    <v-alert
      dense
      color="orange"
      type="info"
      class="alert-custom warning-alert p-3"
      v-if="message"
    >
      <span>{{message}}</span>
    </v-alert>
  </div>
</template>

<script>
import { _alert } from "@/_helpers/function.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import { masterRateService } from "@/_services/MasterRate/masterRate.service.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import RateDerivation from '../Utils/RateDerivation.vue';

export default {
  components: {
    "date-picker": DatePicker,
    Treeselect,
    "rate-derivation": RateDerivation
  },
   mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  data() {
    return {
      isNote: true,
      isLoading: true,
      systemLang: this.$i18n.locale,
      ListProduceMaster: [],
      listProduce: [],
      selectedProduce: [],
      dataMasterRate: [],

      dataRoomRateFormula: [],
      allRoomRate: [],
      roomRateMaster: [],
      roomRateChild: [],
      dataRoomRateFormulaByDate: [],
      multiplierOption: {
        prefix: "",
        locale: "vi",
        length: 3,
        precision: 2,
      },
      itemAdd: {
        idMaster: null,
        idChild: null,
        rateIndex: 1,
        rateSupplement: 0,
        rateAdditional: 0,
      },
      applicableType: [
        {
          text: this.$t("PRICE"),
          value: "price",
          shortText: this.$t("PRICE_FORMULA"),
          bitFlag: 0,
        },
        {
          text: this.$t("minStay"),
          value: "minStay",
          shortText: "MS",
          bitFlag: 32,
        },
        {
          text: this.$t("maxStay"),
          value: "maxStay",
          shortText: "MXS",
          bitFlag: 64,
        },
        {
          text: this.$t("minStayArrival"),
          value: "minStayArrival",
          shortText: "MSA",
          bitFlag: 256,
        },
        {
          text: this.$t("maxStayArrival"),
          value: "maxStayArrival",
          shortText: "MXSA",
          bitFlag: 512,
        },
        {
          text: this.$t("minBookingWindow"),
          value: "minBookingWindow",
          shortText: "MBW",
          bitFlag: 8,
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "maxBookingWindow",
          shortText: "MXBW",
          bitFlag: 16,
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "minBookingWindowByHour",
          shortText: "MBWH",
          bitFlag: 4096,
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "maxBookingWindowByHour",
          shortText: "XBWH",
          bitFlag: 8192,
        },
        {
          text: this.$t("exactStay"),
          value: "exactStay",
          shortText: "ES",
          bitFlag: 128,
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exactStayArrival",
          shortText: "ESA",
          bitFlag: 1024,
        },
        {
          text: this.$t("closedOnArrival"),
          value: "closedOnArrival",
          shortText: "CTA",
          bitFlag: 2,
        },
        {
          text: this.$t("closedOnDeparture"),
          value: "closedOnDeparture",
          shortText: "CTD",
          bitFlag: 4,
        },
        {
          text: this.$t("closed"),
          value: "closed",
          shortText: "SS",
          bitFlag: 1,
        },
      ],
      applicableTypeSelected: [],
      maxHeight: 390,
      isScroll: false,
      bitSetupPrice: 2048,
      dataRoomRateLoading: false,
      listData: [],
      message: null,
    };
  },
  computed: {
    filterRestrictions() {
      let restrictionList = [
        {
          text: this.$t("PRICE_FORMULA"),
          value: "price",
          shortText: this.$t("PRICE_FORMULA"),
          bitFlag: 0,
        },
        {
          text: this.$t("PRICE"),
          value: "price",
          shortText: this.$t("PRICE"),
          bitFlag: 2048,
        },
        {
          text: this.$t("minStay"),
          value: "minStay",
          shortText: "MS",
          bitFlag: 32,
        },
        {
          text: this.$t("maxStay"),
          value: "maxStay",
          shortText: "MXS",
          bitFlag: 64,
        },
        {
          text: this.$t("minStayArrival"),
          value: "minStayArrival",
          shortText: "MSA",
          bitFlag: 256,
        },
        {
          text: this.$t("maxStayArrival"),
          value: "maxStayArrival",
          shortText: "MXSA",
          bitFlag: 512,
        },
        {
          text: this.$t("minBookingWindow"),
          value: "minBookingWindow",
          shortText: "MBW",
          bitFlag: 8,
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "maxBookingWindow",
          shortText: "MXBW",
          bitFlag: 16,
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "minBookingWindowByHour",
          shortText: "MBWH",
          bitFlag: 4096,
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "maxBookingWindowByHour",
          shortText: "XBWH",
          bitFlag: 8192,
        },
        {
          text: this.$t("exactStay"),
          value: "exactStay",
          shortText: "ES",
          bitFlag: 128,
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exactStayArrival",
          shortText: "ESA",
          bitFlag: 1024,
        },
        {
          text: this.$t("closedOnArrival"),
          value: "closedOnArrival",
          shortText: "CTA",
          bitFlag: 2,
        },
        {
          text: this.$t("closedOnDeparture"),
          value: "closedOnDeparture",
          shortText: "CTD",
          bitFlag: 4,
        },
        {
          text: this.$t("closed"),
          value: "closed",
          shortText: "SS",
          bitFlag: 1,
        },
      ];
      if (this.applicableTypeSelected.length == 0) {
        return restrictionList;
      }
      return restrictionList.filter((e) => this.applicableTypeSelected.includes(e.value));
    }
  },
  created() {
    this.currency = this.priceOptionsVi.suffix;
    this.getProduceMaster();
  },
  watch: {},
  methods: {
    toggleRestriction(date, bitFlag) {
      if ((date.restrictionType & bitFlag) !== 0) {
        date.restrictionType -= bitFlag;
      } else {
        date.restrictionType += bitFlag;
      }
    },
    listFomulaLoadMores(event) {
      const container = event.target;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
        const listLength = this.listData.length;
        if (this.dataRoomRateLoading || listLength >= this.dataRoomRateFormulaByDate.length) return;
        this.dataRoomRateLoading = true;
        setTimeout(() => {
          const nextBatch = this.dataRoomRateFormulaByDate.slice(listLength, listLength + 20);
          this.listData = [...this.listData, ...nextBatch];
          this.dataRoomRateLoading = false;
        }, 1500);
        this.$forceUpdate();
      }
    },
    checkScroll() {
      let table = this.$refs.tableSetup;
      if (table && table.clientHeight < table.scrollHeight && !this.isNote) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
    onResize() {
      let page = this.$refs.viewPage;
      if (page) {
        this.maxHeight = page.clientHeight - 282;
      }
    },
    isChecked(restrictionType, bitFlag) {
      return (restrictionType & bitFlag) !== 0;
    },
    getProduceMaster() {
      masterRateService.getRoomRateWithFormula().then((res) => {
        if (res.responseCode === 0) {
          this.ListProduceMaster = res.data;
          this.listProduce = res.data.map((e) =>
            Object.assign(
              {},
              {
                text:
                  e.roomTypeI18n.find((i) => i.lang === this.defaultI18n).name +
                  " - " +
                  e.ratePlanI18n.find((i) => i.lang === this.defaultI18n).name +
                  " - " +
                  e.otaI18n.find((i) => i.lang === this.defaultI18n).name,
                value: e.derivationId,
              }
            )
          );
          let formulaSelected = localStorage.getItem("derivationId");
          if (formulaSelected) {
            this.selectedProduce.push(formulaSelected);
          } else {
            let data = res.data.map((e) => e.derivationId);
            this.selectedProduce = [...data];
          }
          this.changeSearchCondition();
        }
      });
    },
    changeSearchCondition() {
      this.isLoading = true;
      this.dataRoomRateFormulaByDate = [];
      masterRateService.getRoomRateWithFormulaDate(this.selectedProduce).then((res) => {
        if (res.responseCode === 0) {
          this.dataRoomRateFormulaByDate = res.data;
          this.dataRoomRateFormulaByDate.forEach((e) => {
            e.DERIVED_PRODUCT = e.roomTypeI18n.find((x) => x.lang == this.defaultI18n).name
              + '-' + e.ratePlanI18n.find((x) => x.lang == this.defaultI18n).name
              + '-' + e.otaI18n.find((x) => x.lang == this.defaultI18n).name;
            e.MASTER_PRODUCT = e.master.roomTypeI18n.find((x) => x.lang == this.defaultI18n).name
              + '-' + e.master.ratePlanI18n.find((x) => x.lang == this.defaultI18n).name
              + '-' + e.master.otaI18n.find((x) => x.lang == this.defaultI18n).name;
            e.dates = e.dates.map((date) =>
              Object.assign({}, date, {
                dateSelect: [
                  new Date(moment(date.startDate)),
                  new Date(moment(date.endDate)),
                ],
                isEdit: true,
              })
            ).sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
          });
          this.listData = this.dataRoomRateFormulaByDate.slice(0,20);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    addDatePriodSpecialPrice(item) {
      let prevPeriod = null;
      const tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 365 * 2);
      if (item.dates.filter((e) => e.active !== 2).length > 0) {
        let lastDate = item.dates.filter((e) => e.active !== 2)
        .sort((a, b) => new Date(a.dateSelect.startDate) - new Date(b.dateSelect.startDate));
        prevPeriod = lastDate[lastDate.length - 1];
        if (new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >= tomorrow) {
          return;
        }
      }
      let from ,to;
      if (prevPeriod) {
        from = moment(prevPeriod.dateSelect[1]).add(1, "day").format("YYYY-MM-DD");
        to = moment(prevPeriod.dateSelect[1]).add(2, "day").format("YYYY-MM-DD");
      } else {
        from = moment(new Date()).format("YYYY-MM-DD");
        to = moment(new Date()).add(1, "day").format("YYYY-MM-DD");
      }
      const ob = {
        derivationDateRangeId: null,
        active: 1,
        dateSelect: [new Date(from), new Date(to)],
        isEdit: true,
      };

      let items = this.ListProduceMaster.find((e) => e.derivationId == item.derivationId);
      const cp = JSON.parse(JSON.stringify(items));
      
      ob.restrictionType = cp.restrictionType;
      ob.roomRateDerivationsDenominatorList = cp.roomRateDerivationsDenominatorList;
      ob.rateIndex = cp.rateIndex;
      ob.rateSupplement = cp.rateSupplement;
      ob.rateAdditional = cp.rateAdditional;
      item.dates.push(ob);
    },
    getRoomRateWithFormula() {
      masterRateService.getRoomRateWithFormula().then((res) => {
        if (res.responseCode === 0) {
          this.dataRoomRateFormula = res.data.map((e) =>
            Object.assign({}, e, { isEdit: true })
          );
          this.getAllRoomRate();
        }
      });
    },
    saveFormula(item) {
      const body = {
        derivationId: item.derivationId,
        children: {
          ratePlanId: item.ratePlanId,
          roomTypeId: item.roomTypeId,
          id: item.id,
        },
        master: {
          ratePlanId: item.master.ratePlanId,
          roomTypeId: item.master.roomTypeId,
          id: item.id,
        },
        rateIndex: +item.rateIndex,
        rateSupplement: +item.rateSupplement,
        rateAdditional: +item.rateAdditional,
      };
      masterRateService
        .saveFormulaItem(body)
        .then((res) => {
          if (res.responseCode === 0) {
            item.isEdit = true;
          }
        })
        .finally(() => (this.isLoading = false));
    },
    updateFormula() {
      let check = false;
      this.dataRoomRateFormulaByDate.forEach((e) => {
        let arrDate = [];

        e.dates.forEach((date) => {
          if (date.active !== 2) {
            arrDate.push(date.dateSelect);
          }
        });
        const dates = [];
        arrDate.forEach((date) => {
          if (this.get_day_of_time(new Date(date[0]), new Date(date[1])) > 365) {
            _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
            check = true;
            return true;
          }
          let fromDate = moment(date[0], "YYYY-MM-DD");
          let toDate = moment(date[1], "YYYY-MM-DD");
          while (fromDate <= toDate) {
            dates.push(fromDate.format("YYYY-MM-DD"));
            fromDate = moment(fromDate).add(1, "day");
          }
        });
        if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
          _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
          check = true;
          return;
        }
      });
     
      if (!check) {
        this.isLoading = true;
        const body = [];
        this.dataRoomRateFormulaByDate.forEach((e) => {
          const arr = [];
          e.dates.forEach((date) => {
            let fromDate = moment(date.dateSelect[0]).format("YYYY-MM-DD");
            let toDate = moment(date.dateSelect[1]).format("YYYY-MM-DD");
            arr.push({
              derivationDateRangeId: date.derivationDateRangeId,
              active: date.active,
              rateIndex: +date.rateIndex,
              rateSupplement: +date.rateSupplement,
              rateAdditional: +date.rateAdditional,
              startDate: fromDate,
              endDate: toDate,
              restrictionType: date.restrictionType,
              roomRateDerivationDenominatorList: date.roomRateDerivationsDenominatorList
            });
          });
          body.push({
            derivationId: e.derivationId,
            dates: [...arr],
          });
        });
        try {
          masterRateService
          .updateRoomRateFormulaDate(body)
          .then((res) => {
            _alert(res, this.$t(res.data), false);
            this.changeSearchCondition();
          });
        } catch (error) {
          this.isLoading = false;
          this.message = this.$t('WAITING_UPDATE');
          setTimeout(() => {
            this.message = null;
          }, 5000)
        }
      } else {
        return;
      }
    },
    _moment: moment,
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
.th {
  text-transform: uppercase;
  color: rgba(38, 38, 38, 0.7) !important;
  line-height: 24px;
  font-weight: bold;
  font-size: 12px;
  background: #fafafa;
  border-bottom: 1px solid #ccc;
}

.special-price + div {
  display: none;
}

.add-person {
  padding-left: 10px;
  z-index: 99999999;
}

.delete-person {
  padding-left: 10px;
  z-index: 99999999;
}

.copy-price {
  left: -8px;
  top: 8px;
  position: absolute;
  z-index: 99999999;
}

.tab-header {
  background-color: #fff;
  padding: 25px 15px 10px 15px;
}

.restriction-ota {
  font-size: 14px;

  h6 {
    font-size: 14px;

    &.room-title {
      background: #f0f0f0;
      padding: 10px;
      margin: 0;
      border-radius: 5px;
    }
  }

  .sale-package-info {
    align-items: center;
    border-bottom: 1px solid #dedddd;
    padding-bottom: 5px;
  }

  .col-md-12:last-child {
    .sale-package-info {
      border-bottom: none;
    }
  }
}

table {
  td {
    vertical-align: middle;
  }
}

.mx-datepicker-range {
  width: 200px;
}
</style>
